import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router";
import { useApi } from "./auth";
import { backend_url } from "./constants";
import ResultHeader from "./components/ResultHeader";
import ResultBody from "./components/ResultBody";
import Loading from "./components/Loading";
import { useReactToPrint } from "react-to-print";
import { useResultStore } from "./ResultStore";
import { observer } from "mobx-react-lite";


function Result() {
  const { uuid } = useParams();
  const [isPrinting, setIsPrinting] = useState(false);
  const store = useResultStore();
  const contentRef = useRef();
  // We store the resolve Promise being used in `onBeforePrint` here
  const promiseResolveRef = useRef(null);
  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
      promiseResolveRef.current();
    }
  }, [isPrinting]);
  const handlePrint = useReactToPrint({
    contentRef,
    onBeforePrint: () => {
      return new Promise((resolve) => {
        promiseResolveRef.current = resolve;
        setIsPrinting(true);
        
      });
    },
    onAfterPrint: () => {
      // Reset the Promise resolve so we can print again
      promiseResolveRef.current = null;
      setIsPrinting(false);
    },
  });

  useEffect(() => {
    let cancelled = false;
    store.fetchRun(uuid);

    return () => {
      cancelled = true;
    };
  }, [uuid]);
  if (store.loading) return <Loading />;
  if (store.runObject == null) return <div>Can't access result</div>;

  return (
    <div>
      {isPrinting ? null : (
        <ResultHeader object={store.runObject} exportFunc={handlePrint} />
      )}
      <ResultBody
        ref={contentRef}
        isPrinting={isPrinting}
        store={store}
      />
    </div>
  );
}

export default observer(Result);
